module.exports = require("babel-runtime/helpers/inherits");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/inherits"
// module id = 11
// module chunks = 0